<template>
  <div class="withdrawal-rule">
    <!-- 规则说明 -->
    <el-alert
      title="提现规则说明"
      type="info"
      :closable="false"
      show-icon
      class="rule-alert">
      <template slot="default">
        <p>1. 总机构规则为默认提现配置，当分机构未单独配置时使用总机构规则</p>
        <p>2. 机构专属规则优先级高于总机构规则，不同机构可设置差异化配置</p>
        <p>3. 手续费 = 提现金额 × 手续费率，实际到账 = 提现金额 - 手续费，手续费率为0（即不收取手续费）时，实际到账 = 提现金额</p>
      </template>
    </el-alert>

    <el-row :gutter="20">
      <!-- 提现规则 -->
      <el-col :span="12">
        <div class="rule-card global-rule">
          <div class="rule-header">
            <div class="rule-title">
              <i class="el-icon-setting"></i>
              <span>提现规则</span>
            </div>
            <el-tag size="small" :type="isConfigured ? 'success' : 'danger'">
              {{ isConfigured ? '生效中' : '未配置' }}
            </el-tag>
          </div>
          <el-form :model="ruleForm" :rules="ruleRules" ref="ruleForm" label-width="100px" label-position="left" size="small">
            <div class="form-section">
              <div class="section-title">金额限制</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="最低提现" prop="minAmount">
                    <el-input-number v-model="ruleForm.minAmount" :min="1" :max="10000" :precision="0" style="width: 100%;" @change="handleMinAmountChange"></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="最高提现" prop="maxAmount">
                    <el-input-number v-model="ruleForm.maxAmount" :min="100" :max="100000" :precision="0" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="form-section">
              <div class="section-title">费率与限制</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="手续费率" prop="feeRate">
                    <el-input-number v-model="ruleForm.feeRate" :min="0" :max="10" :precision="2" :step="0.1" style="width: 100%;">
                      <template slot="append">%</template>
                    </el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="每日次数" prop="dailyLimit">
                    <el-input-number v-model="ruleForm.dailyLimit" :min="1" :max="10" style="width: 100%;"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="form-section">
              <div class="section-title">到账设置</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="到账天数" prop="arrivalDays">
                    <el-select v-model="ruleForm.arrivalDays" style="width: 100%;">
                      <el-option
                        v-for="item in arrivalDaysOptions"
                        :key="item.value"
                        :value="item.value"
                        :label="item.label">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="提现时段" required>
                    <div class="flex-start">
                        <el-form-item prop="startTime" style="display: inline-block; margin-right: 5px;">
                      <el-time-select
                        v-model="ruleForm.startTime"
                        :picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                        placeholder="开始"
                        style="width: 100%;"
                        @change="handleStartTimeChange">
                      </el-time-select>
                    </el-form-item>
                    <el-form-item prop="endTime" style="display: inline-block;">
                      <el-time-select
                        v-model="ruleForm.endTime"
                        :picker-options="{ start: '00:00', step: '01:00', end: '24:00' }"
                        placeholder="结束"
                        style="width: 100%;">
                      </el-time-select>
                    </el-form-item>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="form-actions">
              <el-button type="primary" icon="el-icon-check" @click="handleSave" :loading="saveLoading">保存规则</el-button>
            </div>
          </el-form>
        </div>
      </el-col>

      <!-- 规则预览 -->
      <el-col :span="12">
        <div class="rule-card preview-card">
          <div class="rule-header">
            <span class="rule-title"><i class="el-icon-view"></i> 规则预览</span>
          </div>
          <div class="preview-content" v-if="isConfigured">
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">最低提现</span>
                  <span class="preview-value" style="color: #409EFF;">{{ ruleForm.minAmount }}元</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">最高提现</span>
                  <span class="preview-value" style="color: #409EFF;">{{ ruleForm.maxAmount }}元</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">手续费率</span>
                  <span class="preview-value" style="color: #409EFF;">{{ ruleForm.feeRate }}%</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">每日次数</span>
                  <span class="preview-value" style="color: #409EFF;">{{ ruleForm.dailyLimit }}次</span>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">到账天数</span>
                  <span class="preview-value" style="color: #409EFF;">{{ getArrivalDaysLabel(ruleForm.arrivalDays) }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="preview-item">
                  <span class="preview-label">提现时段</span>
                  <span class="preview-value" style="color: #409EFF;">{{ ruleForm.startTime }} - {{ ruleForm.endTime }}</span>
                </div>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <div class="preview-example">
              <div class="example-title">提现计算示例</div>
              <div class="example-content">
                <p>假设提现金额为 <strong class="text-primary">¥1000.00</strong></p>
                <p>手续费率：<strong class="text-primary">{{ ruleForm.feeRate.toFixed(2) }}%</strong></p>
                <p>手续费：<strong class="text-primary">¥{{ calculateFee(1000).toFixed(2) }}</strong></p>
                <p>实际到账：<strong class="text-primary">¥{{ calculateActualAmount(1000).toFixed(2) }}</strong></p>
              </div>
            </div>
          </div>
          <div class="preview-content" v-else>
            <div class="preview-empty">
              <span style="color: #909399;">请先配置提现规则</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'WithdrawalRule',
  data() {
    return {
      isConfigured: false, // 是否已配置
      ruleForm: {
        minAmount: undefined,
        maxAmount: undefined,
        feeRate: undefined,
        dailyLimit: undefined,
        arrivalDays: undefined,
        startTime: null,
        endTime: null
      },
      ruleRules: {
        minAmount: [
          { required: true, message: '请输入最低提现金额', trigger: 'blur' }
        ],
        maxAmount: [
          { required: true, message: '请输入最高提现金额', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value && this.ruleForm.minAmount && value <= this.ruleForm.minAmount) {
                callback(new Error('最高提现金额必须大于最低提现金额'))
              } else {
                callback()
              }
            }, 
            trigger: 'blur' 
          }
        ],
        feeRate: [
          { required: true, message: '请输入手续费率', trigger: 'blur' }
        ],
        dailyLimit: [
          { required: true, message: '请输入每日次数', trigger: 'blur' }
        ],
        arrivalDays: [
          { required: true, message: '请选择到账天数', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          { 
            validator: (rule, value, callback) => {
              if (value && this.ruleForm.startTime) {
                const startHour = parseInt(this.ruleForm.startTime.split(':')[0])
                const endHour = parseInt(value.split(':')[0])
                if (endHour <= startHour) {
                  callback(new Error('结束时间必须大于开始时间'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            }, 
            trigger: 'change' 
          }
        ]
      },
      saveLoading: false
    }
  },
  computed: {
    /**
     * 到账天数选项
     * 作者：孙艺
     */
    arrivalDaysOptions() {
      return this.$const.CHANNEL_WITHDRAWAL_ARRIVAL_DAYS || []
    }
  },
  created() {
    this.loadRule()
  },
  methods: {
    /**
     * 加载提现规则配置
     * 使用接口：GET /api/v1/channel/withdrawalConfig
     * 作者：孙艺
     */
    async loadRule() {
      try {
        const res = await this.$axios.get('/api/v1/channel/withdrawalConfig')
        if (res && res.code === 1 && res.data) {
          const data = res.data
          // 判断是否有配置数据（检查是否有 id）
          this.isConfigured = !!(data.id !== null && data.id !== undefined)
          
          if (this.isConfigured) {
            // 有配置数据时，进行字段映射和格式转换
            this.ruleForm = {
              minAmount: data.minWithdrawalAmount !== null && data.minWithdrawalAmount !== undefined ? parseFloat(data.minWithdrawalAmount) : null,
              maxAmount: data.maxWithdrawalAmount !== null && data.maxWithdrawalAmount !== undefined ? parseFloat(data.maxWithdrawalAmount) : null,
              feeRate: data.serviceFeeRate !== null && data.serviceFeeRate !== undefined ? parseFloat((parseFloat(data.serviceFeeRate) * 100).toFixed(2)) : null, // 小数转百分比
              dailyLimit: data.dailyCount !== null && data.dailyCount !== undefined ? parseInt(data.dailyCount) : null,
              arrivalDays: data.arrivalDays !== null && data.arrivalDays !== undefined ? String(data.arrivalDays) : null,
              startTime: data.withdrawalStartTime !== null && data.withdrawalStartTime !== undefined ? this.formatTimeFromHour(data.withdrawalStartTime) : null,
              endTime: data.withdrawalEndTime !== null && data.withdrawalEndTime !== undefined ? this.formatTimeFromHour(data.withdrawalEndTime) : null
            }
          }
        } else {
          // 接口返回无数据，显示未配置
          this.isConfigured = false
        }
      } catch (error) {
        console.error('加载提现规则失败:', error)
        this.$message.error('加载提现规则失败')
        // 出错时也显示未配置
        this.isConfigured = false
      }
    },
    /**
     * 保存提现规则配置
     * 使用接口：POST /api/v1/channel/withdrawalConfig/save
     * 作者：孙艺
     */
    async handleSave() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          try {
            // 字段映射：前端字段 -> 接口字段
            const params = {
              minWithdrawalAmount: this.ruleForm.minAmount,
              maxWithdrawalAmount: this.ruleForm.maxAmount,
              serviceFeeRate: parseFloat(this.ruleForm.feeRate) / 100, // 百分比转小数
              dailyCount: this.ruleForm.dailyLimit,
              arrivalDays: this.ruleForm.arrivalDays,
              withdrawalStartTime: this.formatTimeToHour(this.ruleForm.startTime),
              withdrawalEndTime: this.formatTimeToHour(this.ruleForm.endTime)
            }
            
            const res = await this.$axios.post('/api/v1/channel/withdrawalConfig/save', params)
            if (res && res.code === 1) {
              this.$message.success('保存成功')
              // 保存成功后，重新加载配置，更新 isConfigured 状态
              await this.loadRule()
            }
          } catch (error) {
            console.error('保存提现规则失败:', error)
            this.$message.error('保存提现规则失败')
          } finally {
            this.saveLoading = false
          }
        }
      })
    },
    /**
     * 将小时数转换为时间格式（如：9 -> "09:00"）
     * 作者：孙艺
     */
    formatTimeFromHour(hour) {
      if (hour === null || hour === undefined) return null
      const h = parseInt(hour)
      return `${this.$utils.zfill(h)}:00`
    },
    /**
     * 将时间格式转换为小时数（如："09:00" -> 9）
     * 作者：孙艺
     */
    formatTimeToHour(timeStr) {
      if (!timeStr) return 9
      const parts = timeStr.split(':')
      return parseInt(parts[0])
    },
    /**
     * 刷新规则数据
     * 作者：孙艺
     */
    refresh() {
      this.loadRule()
    },
    /**
     * 最低提现金额改变时，重新验证最高提现金额
     * 作者：孙艺
     */
    handleMinAmountChange() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField('maxAmount')
      }
    },
    /**
     * 开始时间改变时，重新验证结束时间
     * 作者：孙艺
     */
    handleStartTimeChange() {
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.validateField('endTime')
      }
    },
    /**
     * 获取到账天数标签
     * 作者：孙艺
     */
    getArrivalDaysLabel(days) {
      const map = {
        '0': 'T+0 实时到账',
        '1': 'T+1 次日到账',
        '3': 'T+3 三日到账',
        '7': 'T+7 七日到账'
      }
      return map[days] || '-'
    },
    /**
     * 计算手续费
     * 作者：孙艺
     */
    calculateFee(amount) {
      if (!this.ruleForm.feeRate) return 0
      return amount * this.ruleForm.feeRate / 100
    },
    /**
     * 计算实际到账金额
     * 作者：孙艺
     */
    calculateActualAmount(amount) {
      if (!this.ruleForm.feeRate) return amount
      return amount - this.calculateFee(amount)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../channel.less';

.withdrawal-rule {
  .rule-alert {
    margin-bottom: 16px;
    
    p {
      margin: 4px 0;
      font-size: 12px;
    }
  }
}

// 规则卡片
.rule-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  min-height: 500px;
  
  .rule-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #EBEEF5;
    
    .rule-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      
      i {
        margin-right: 8px;
        font-size: 18px;
        color: #409EFF;
      }
    }
  }
  
  &.global-rule {
    .rule-title i {
      color: #409EFF;
    }
  }
}

// 表单分区
.form-section {
  margin-bottom: 20px;
  
  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 12px;
    padding-left: 10px;
    border-left: 3px solid #409EFF;
  }
}

// 表单操作
.form-actions {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #EBEEF5;
}

// 预览卡片
.preview-card {
  .preview-content {
    .el-row {
      margin-bottom: 0;
      
      .el-col {
        .preview-item {
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #f5f5f5;

          .preview-label {
            color: #909399;
            font-size: 13px;
          }

          .preview-value {
            color: #303133;
            font-size: 13px;
            font-weight: 500;

            &.highlight {
              color: #409EFF;
              font-size: 16px;
            }
          }
        }
      }
    }

    .preview-empty {
      padding: 40px 0;
      text-align: center;
      color: #909399;
      font-size: 14px;
    }

    .preview-example {
      margin-top: 16px;
      padding: 16px;
      background: #f5f7fa;
      border-radius: 6px;

      .example-title {
        font-size: 13px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 8px;
      }

      .example-content {
        font-size: 13px;
        color: #606266;

        p {
          margin: 4px 0;
        }

        .text-warning {
          color: #E6A23C;
          font-size: 16px;
        }

        .text-success {
          color: #67C23A;
          font-size: 18px;
        }
      }
    }
  }
}
</style>

